// eslint-disable-next-line
import { injectable } from "inversify";
import { IStoreRole } from "../../models/User";
import { IApiResponse, IHttpService } from "../http-service";
import { rootContainer, TYPE } from '../container/root';

export interface IStoreRolesWithPermissionsResponse {
    roles: IStoreRole[],
    permissions: { [key: number]: string }[]
}

@injectable()
class RoleService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async loadStoreRolesWithPermissions(): Promise<IStoreRolesWithPermissionsResponse> {
        const res = await this.httpService.get<IApiResponse<IStoreRolesWithPermissionsResponse>>(`/rms-api/user/roles`);
        return res.payload;
    }
}

export default RoleService;
